import { Navigate } from "react-router-dom";

export const BlogPage = () => {
  return <Navigate to="/news" replace />;
};
